import React, { JSX, useMemo } from 'react';

import { ViewStyle } from 'react-native';

import Animated, {
    SharedValue,
    useAnimatedStyle,
} from 'react-native-reanimated';

import { EPGConfig } from '../types';
import styles from './styles';

type Props = {
    config: EPGConfig;
    xScrollOffset: SharedValue<number>;
    xNowOffset: SharedValue<number>;
    renderLine?: () => JSX.Element;
};

const NowIndicatorLine = ({
    config,
    xScrollOffset,
    xNowOffset,
    renderLine,
}: Props) => {
    const animatedStyle = useAnimatedStyle(
        () =>
            ({
                opacity: xScrollOffset.value > xNowOffset.value ? 0 : 1,
                transform: [
                    {
                        translateX:
                            xNowOffset.value -
                            xScrollOffset.value +
                            config.channelWidth,
                    },
                ],
            } as ViewStyle),
        [],
    );

    const style = useMemo(
        () => [styles.container, animatedStyle],
        [animatedStyle],
    );

    return (
        <Animated.View style={style} pointerEvents="none">
            {renderLine?.()}
        </Animated.View>
    );
};

export default NowIndicatorLine;
